import React from 'react';
import { NavLink } from 'react-router-dom';
import './subscriptionNavBar.css';
import logo from '../../assets/logo.jpeg';
import { useNavigate } from "react-router-dom";

const SubscriptionNavBar = () => {
  const navigate = useNavigate();
  const goBack = () => {
    // window.history.back();
    navigate("/profile");
  };

  return (
    <div className="subscriptionNavbar-container">
      <NavLink to="/">
        <img src={logo} alt="Logo" className="subscription-logo" />
      </NavLink>
      <button onClick={goBack} className="go-back-button">
      Back to profile
      </button>
    </div>
  );
};

export default SubscriptionNavBar;
